import { ChangeEvent, useEffect, useState } from "react";
import { RETRIEVE_SHEET_JDL, IMPORT_ROLES_DB_END_POINT } from "../../../config/config";
import { api, getToken } from "../../../services/apis/auth-api/apiUrl";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDatabase, faSpinner } from "@fortawesome/free-solid-svg-icons";

interface sheetJDLProps {
    position_title: string,
    status: string,
    career_level: string,
    fte: number,
    budget: string,
    job_description : string,
    client_name: string,
    domain_name: string,
    segment_name: string,
    sub_segment_name: string,
    saved : boolean,
    date_created : string,
    date_updated : string,
    checked : boolean
}

export default function SpreadSheetJD () {
    const [jdLoading, setJdLoading] = useState<boolean>(false);
    const [sheetJd, setSheetJd] = useState<sheetJDLProps[]>([]);
    const [sheetRoles, setSheetRoles] = useState<sheetJDLProps[]>([]);
    const [sheetName, setSheetName] = useState<string | null>(null);
    const [allChecked, setAllChecked] = useState<boolean>(false);
    const [showSaveButton, setShowSaveButton] = useState<boolean>(false);
    const [saveDbLoading, setSaveDbLoading] = useState<boolean>(false);
    const [loadRoles, setLoadRole] = useState<boolean | null>(null);
    const [dbStatFilter, setDbStatFilter] = useState<string>('all');

    const handleSheetName = (e : ChangeEvent<HTMLSelectElement>) => {
        const name = e.target.value;
        setLoadRole(true);
        if(name === ''){
            setSheetName(null);
        }else{
            setSheetName(name);
        }
    }

    const handleSearch = (e : ChangeEvent<HTMLInputElement>) => {
        const searhKey = e.target.value.toLowerCase();
        const filteredRoles = sheetJd.filter(role => 
            role.position_title.toLowerCase().includes(searhKey) ||
            role.client_name.toLowerCase().includes(searhKey) ||
            role.domain_name.toLowerCase().includes(searhKey) ||
            role.segment_name.toLowerCase().includes(searhKey) ||
            role.sub_segment_name.toLowerCase().includes(searhKey) ||
            role.status.toLowerCase().includes(searhKey)
        );
        setSheetRoles(filteredRoles);
    }

    const handleSelectAllRoles = (e : ChangeEvent<HTMLInputElement>) => {
        setSheetRoles(sheetRoles.map(role => 
           !role.saved ? ({...role, checked: e.target.checked}) : role ));
        setAllChecked(e.target.checked);
        setShowSaveButton(e.target.checked);
    }

    const handleSelectRole = (index : number , e : ChangeEvent<HTMLInputElement>) => {
        const roles = [...sheetRoles];
        roles[index] = {...roles[index], checked : e.target.checked};
        setSheetRoles(roles);

        const allChecked = roles.every(role => role.checked);
        setAllChecked(allChecked);
        setShowSaveButton(e.target.checked ? true : allChecked);
    }

    const handleSaveToDatabase = async() => {
        if(!showSaveButton || saveDbLoading) return false;
        const selectedJds = sheetRoles.filter(role => role.checked === true);
        if(selectedJds.length <= 0) return alert('No role selected.');
        setSaveDbLoading(true);

        try{
            await api.post(
                IMPORT_ROLES_DB_END_POINT,
                selectedJds,
                {
                    headers : {'Authorization' : 'Bearer '+getToken()}
                }
            );
            setLoadRole(true);
            setSaveDbLoading(false);
        }catch(e){
            alert('Failed to save roles')
            setLoadRole(false);
            setSaveDbLoading(false);
        }

        console.log(selectedJds);
    }

    useEffect(()=>{
        if(loadRoles){
            setLoadRole(null);
            const getSheetRoles = async() => {
                if(sheetName === null) return false;
                setJdLoading(true);
                try{
                    const roles = await api.get(
                        RETRIEVE_SHEET_JDL+sheetName,
                        {
                            headers : {'Authorization' : 'Bearer '+getToken()}
                        }
                    )
                    const sheetRoles = roles.data as sheetJDLProps[];
                    setSheetJd(sheetRoles);
                    setSheetRoles(sheetRoles);
                    setJdLoading(false);
                }catch(e){
                    alert('Something went wrong');
                    setJdLoading(false);
                }
            }
            getSheetRoles();
        }
    },[sheetName, loadRoles])

    useEffect(()=>{
        switch(dbStatFilter){
            case 'all':
                setSheetRoles(sheetJd);
                break;
            case 'in db':
                const storedRoles = sheetJd.filter(role => 
                    role.saved === true
                );
                setSheetRoles(storedRoles);
                break;
            case 'not stored':
                const notStoredRoles = sheetJd.filter(role => 
                    role.saved === false
                );
                setSheetRoles(notStoredRoles);
                break;
        }
    },[dbStatFilter, sheetJd]);

    return (
        <div>
        <div className="w-full bg-white px-2 py-4">
            <h1 className="text-md">
                Spreadsheet Roles
            </h1>
        </div>
        <div className="w-full flex items-center bg-white px-2 py-4">
            <div className="mx-4 text-md text-gray-500">
                {sheetRoles.length} role/s found in spreadsheet.
            </div>
            <div className="ms-auto flex justify-center items-center gap-2">
                <div>
                    <button 
                     type="button"
                     onClick={handleSaveToDatabase}
                     className={
                         showSaveButton ? "border border-gray-400 py-1.5 px-2 rounded hover:bg-gray-200 shadow"  :
                          "border border-gray-400 py-1.5 px-2 rounded hover:bg-gray-200 shadow cursor-not-allowed" 
                        }>
                        {saveDbLoading ? (
                            <>
                                <FontAwesomeIcon className="text-gray-500 animate-spin" icon={faSpinner} />&nbsp;
                                Processing.....
                            </>
                        ) : (
                            <>
                               <FontAwesomeIcon className="text-gray-500" icon={faDatabase} />&nbsp;
                               Save to database
                            </>
                        )}
                        
                    </button>
                </div>
                <div>
                    <select onChange={handleSheetName} className="text-box max-w-56 h-9">
                        <option value="">Select SpreadSheet</option>
                        <option value="TECH">ERS - TECHNOLOGY & IS</option>
                        <option value="CF">ERS - CORPORATE FUNCTIONS</option>
                        <option value="OPS">ERS - OPERATIONS</option>
                        <option value="SHARED">SHARED ROLES</option>
                    </select>
                </div>
                <div>
                    <select onChange={(e) => setDbStatFilter(e.target.value)} className="text-box max-w-56 h-9">
                        <option value="all">All</option>
                        <option value="in db">In DB</option>
                        <option value="not stored">Not Stored</option>
                    </select>
                </div>
                <div>
                    <input type="text" onChange={handleSearch} className='text-box h-9' placeholder="Search...." />
                </div>
            </div>
        </div>
        <div className='max-h-96 max-w-full overflow-y-auto overflow-x-auto hide-scrollbar border bg-white'>
            <table className="w-full border">
                <thead className="table-fixed-header border">
                        <tr>
                            <th className='table-headers'>
                                <div>
                                    <input type="checkbox" checked={allChecked} onChange={handleSelectAllRoles} className="check-box" />
                                </div>
                            </th>
                            <th className='table-headers'>Position Title</th>
                            <th className='table-headers'>Client</th>
                            <th className='table-headers'>Domain</th>
                            <th className='table-headers'>Segment</th>
                            <th className='table-headers'>Sub-Segment</th>
                            <th className='table-headers'>Status</th>
                            <th className='table-headers'>DB Status</th>
                        </tr>
                </thead>
                <tbody className="text-center">
                    {jdLoading ? (
                        <>
                        <tr className="">
                            <td className='table-body'>
                                <div className="table-loading"></div>
                            </td>
                            <td className='table-body'>
                                <div className="table-loading"></div>
                            </td>
                            <td className='table-body'>
                                <div className="table-loading"></div>
                            </td>
                            <td className='table-body'>
                                <div className="table-loading"></div>
                            </td>
                            <td className='table-body'>
                                <div className="table-loading"></div>
                            </td>
                            <td className='table-body'>
                                <div className="table-loading"></div>
                            </td>
                            <td className='table-body'>
                                <div className="table-loading"></div>
                            </td>
                            <td className='table-body'>
                                <div className="table-loading"></div>
                            </td>
                        </tr>
                        <tr className="">
                            <td className='table-body'>
                                <div className="table-loading"></div>
                            </td>
                            <td className='table-body'>
                                <div className="table-loading"></div>
                            </td>
                            <td className='table-body'>
                                <div className="table-loading"></div>
                            </td>
                            <td className='table-body'>
                                <div className="table-loading"></div>
                            </td>
                            <td className='table-body'>
                                <div className="table-loading"></div>
                            </td>
                            <td className='table-body'>
                                <div className="table-loading"></div>
                            </td>
                            <td className='table-body'>
                                <div className="table-loading"></div>
                            </td>
                            <td className='table-body'>
                                <div className="table-loading"></div>
                            </td>
                        </tr>
                        <tr className="">
                            <td className='table-body'>
                                <div className="table-loading"></div>
                            </td>
                            <td className='table-body'>
                                <div className="table-loading"></div>
                            </td>
                            <td className='table-body'>
                                <div className="table-loading"></div>
                            </td>
                            <td className='table-body'>
                                <div className="table-loading"></div>
                            </td>
                            <td className='table-body'>
                                <div className="table-loading"></div>
                            </td>
                            <td className='table-body'>
                                <div className="table-loading"></div>
                            </td>
                            <td className='table-body'>
                                <div className="table-loading"></div>
                            </td>
                            <td className='table-body'>
                                <div className="table-loading"></div>
                            </td>
                        </tr>
                        </>
                    ) : sheetRoles.length <= 0 ? (
                        <tr>
                            <td colSpan={9} className='table-body'>
                                No role found in spreadsheet.
                            </td>
                        </tr>
                    ) : sheetRoles.map((role, index)=>(
                        <tr>
                            <td className='table-body px-4'>
                                <div>
                                    <input type="checkbox" disabled={role.saved} checked={role.checked} onChange={(e)=>handleSelectRole(index, e)} className="check-box" />
                                </div>
                            </td>
                            <td className='table-body px-2'>{role.position_title}</td>
                            <td className='table-body px-2'>{role.client_name}</td>
                            <td className='table-body px-2'>{role.domain_name}</td>
                            <td className='table-body px-2'>{role.segment_name}</td>
                            <td className='table-body px-2'>{role.sub_segment_name}</td>
                            <td className='table-body px-2'>{role.status}</td>
                            <td className='table-body px-2'>
                                <small className={role.saved ? "text-sm w-10 bg-green-500 text-white px-2 rounded shadow" : "text-xs w-10 bg-red-500 text-white rounded shadow"}>
                                    {role.saved ? "In DB" : "Not stored"}
                                </small>
                            </td>
                        </tr>
                    ))}
                    
                </tbody>
            </table>
        </div>
    </div>
    );
}